export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '작업명'}, {name: '신청부서'}, {name: '허가일자'}, {name: '작업구분'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputA_2
      case 2: return func.getContent(value).inputA_0
      case 3: return func.getContent(value).inputA_4
      case 4: return func.getContent(value).categoryLabel
      case 5: return func.getContent(value).stdInfo.writer_name
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_4) {
      nav.dateTarget = 'content$body.inputA_4'
      nav.dateBegin = 'nav.value.inputA_4.0'
      nav.dateEnd = 'nav.value.inputA_4.1'
    }
    return {inputA_4: nav.value.inputA_4, categoryLabel: nav.value.categoryLabel}
  },
  getSearchKeyword: (nav) => {
    return ['content$body.categoryLabel*[:nav.page.p84.categoryLabel]']
  },
}
